import _regeneratorRuntime from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export function createPkce() {
  return _createPkce.apply(this, arguments);
}

function _createPkce() {
  _createPkce = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var code_verifier, code_challenge;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            code_verifier = randomString(96);
            _context.next = 3;
            return createCodeChallenge(code_verifier);

          case 3:
            code_challenge = _context.sent;
            return _context.abrupt("return", {
              code_verifier: code_verifier,
              code_challenge: code_challenge,
              code_challenge_method: "S256"
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createPkce.apply(this, arguments);
}

export function createCodeChallenge(_x) {
  return _createCodeChallenge.apply(this, arguments);
}

function _createCodeChallenge() {
  _createCodeChallenge = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(code_verifier) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = getEncodedUrl;
            _context2.t1 = getBase64;
            _context2.next = 4;
            return getSha256(code_verifier);

          case 4:
            _context2.t2 = _context2.sent;
            _context2.t3 = (0, _context2.t1)(_context2.t2);
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t3));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createCodeChallenge.apply(this, arguments);
}

export function randomString(length) {
  var array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return getEncodedUrl(getBase64(array)).substr(0, length);
}

function getSha256(_x2) {
  return _getSha.apply(this, arguments);
}

function _getSha() {
  _getSha = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(text) {
    var sha256;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return window.crypto.subtle.digest("SHA-256", s2a(text));

          case 2:
            sha256 = _context3.sent;
            return _context3.abrupt("return", new Uint8Array(sha256));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getSha.apply(this, arguments);
}

function getBase64(a) {
  return window.btoa(a2s(a));
}

function getEncodedUrl(base64) {
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/\=+$/, "");
}

function a2s(a) {
  return String.fromCharCode.apply(String, a);
}

function s2a(s) {
  var b = new Uint8Array(s.length);

  for (var i = 0, il = s.length; i < il; i++) {
    b[i] = s.charCodeAt(i);
  }

  return b;
}